import FileSaver from 'file-saver';
import { ConfigType, DeviceParameterConfigType, SIMCredentialing } from '../../pages/bulk-device-management/types';

export const csvHeaderStringOld = 'Asset Make, Asset-SN, Device ID';
export const csvHeaderString = 'Asset Make,Asset-SN,Device ID';
export const csvBulkHeaderString = 'FileTypeID,Description,TransferID,ClassificationID,MastershipID,FileSyncID';
export const csvTemplate = new Blob([csvHeaderString], {
  type: 'text/csv',
});
export const csvBulkFileTemplate = new Blob([csvBulkHeaderString], {
  type: 'text/csv',
});

export const downloadTemplate = () => FileSaver.saveAs(csvTemplate, 'bulk_device_template.csv');
export const downloadBulkFileTemplate = () => FileSaver.saveAs(csvBulkFileTemplate, 'bulk_file_template.csv');
export const csvSIMStringOld = 'Asset Make, Asset-SN, Country';
export const csvSIMHeaderString = 'Asset Make,Asset Serial Number,Country';
export const csvEngineeringTemplateHeaderString = 'Asset Make,Asset Serial Number,Country,LMNO,EnableProfile,EID';
export const csvShortMessageHeaderString = 'Asset Make,Asset Serial Number,Device-Characterization,FileTypeId';
export const csvShortCommandHeaderString = 'Asset Make,Asset Serial Number,Device-Characterization,FileTypeId,Data';
export const csvServiceMeterHourString = 'Asset Make,Asset Serial Number,Device-Characterization,Hour Adjusted';
export const csvDeviceWakeupString = 'Device Id,Device Type';
export const csvConfigFileHeaderString = 'Asset Make,Asset Serial Number,Device-Characterization,FileTypeId,Hash,Hex Payload';
export const csvDeviceParameter_EOD_String = 'Asset Make,Asset Serial Number,Device-Characterization,Eod';
export const csvDeviceParameter_TamperResistance_String = 'Asset Make,Asset Serial Number,Device-Characterization,Disable Derate Start Mode([ normal | derate | disable ]),Disable Derate Tamper Resistance([ off | level_1 | level_2 | level_3 ])';
export const csvSubscription_String = 'Asset Make,Asset Serial Number,Device-Characterization,Subscription Id';
export const csvCommandsInfo = 'Asset Make,Asset Serial Number,Device-Characterization';
export const csvCommandsInfoAssetNSerailNumber = 'Asset Make,Asset Serial Number';
export const csvExportCommand = 'deviceKey,deviceId,deviceType,commandId,statusMessage,fileType,modifiedBy,modifiedDateTime, applicationId'
export const csvModemOnlyFlash= 'Device ID';
export const csvScheduleCommandHeaderString = 'Device Id,Device Type,Data,FileType,Frequency,Action';

const createTemplate = (headerString: string, fileName: string) => {
  const templateString = new Blob([headerString], {
    type: 'text/csv',
  });
  FileSaver.saveAs(templateString, fileName);
}

export const downloadSIMTemplate = (actionType: string): any => {
  switch (actionType) {
    case SIMCredentialing.SimCredential: {
      createTemplate(csvSIMHeaderString, 'sim_credential_template.csv');
      break;
    }
    case SIMCredentialing.EngineeringTemplate: {
      createTemplate(csvEngineeringTemplateHeaderString, 'engineering_template.csv');
      break;
    }
    default:
  }
}

export const getCsvHeaderString = (actionType: string): any => {
  switch (actionType) {
    case ConfigType.ShortCommand: {
      return csvShortCommandHeaderString;
    }
    case ConfigType.ShortMessage: {
      return csvShortMessageHeaderString;
    }
    case ConfigType.SMHAdjust: {
      return csvServiceMeterHourString;
    }
    case ConfigType.ConfigFiles: {
      return csvConfigFileHeaderString;
    }
    case ConfigType.Subscription: {
      return csvSubscription_String;
    }
    case ConfigType.DeviceWakeups: {
      return csvDeviceWakeupString;
    }
    case ConfigType.ScheduleCommand: {
      return csvScheduleCommandHeaderString;
    }
    case DeviceParameterConfigType.EOD: {
      return csvDeviceParameter_EOD_String;
    }
    case DeviceParameterConfigType.TamperResistance: {
      return csvDeviceParameter_TamperResistance_String;
    }
    case SIMCredentialing.SimCredential: {
      return csvSIMHeaderString;
    }
    case SIMCredentialing.EngineeringTemplate: {
      return csvEngineeringTemplateHeaderString;
    }
    default:
      return null;
  }
}

export const handleTepmlateDownloadFireAndForget = (actionType: string, subActionType: string): any => {
  switch (subActionType === 'Parameter Type' ? actionType : subActionType) {
    case ConfigType.ShortCommand: {
      createTemplate(csvShortCommandHeaderString, 'short_command_template.csv');
      break;
    }
    case ConfigType.ShortMessage: {
      createTemplate(csvShortMessageHeaderString, 'short_message_template.csv');
      break;
    }
    case ConfigType.SMHAdjust: {
      createTemplate(csvServiceMeterHourString, 'service_meter_hour.csv');
      break;
    }
    case ConfigType.ConfigFiles: {
      createTemplate(csvConfigFileHeaderString, 'config_file_template.csv');
      break;
    }
    case ConfigType.Subscription: {
      createTemplate(csvSubscription_String, 'subscription_config_template.csv');
      break;
    }
    case ConfigType.DeviceWakeups: {
      createTemplate(csvDeviceWakeupString, 'device_wakeup_template.csv');
      break;
    }
    case ConfigType.ScheduleCommand: {
      createTemplate(csvScheduleCommandHeaderString, 'schedule_command_template.csv');
      break;
    }
    case DeviceParameterConfigType.EOD: {
      createTemplate(csvDeviceParameter_EOD_String, 'eod_config_template.csv');
      break;
    }
    case DeviceParameterConfigType.TamperResistance: {
      createTemplate(csvDeviceParameter_TamperResistance_String, 'tamper_resistance_hour.csv');
      break;
    }
    default:
  }
}

export const downloadTemplateForBulkCommandFetch = () => {
  createTemplate('Asset Make,Asset Serial Number,Device-Characterization(Optional)', 'bulk_command_fetch_template.csv');
}

export const postHeaderString =
  'Asset Make, Asset-SN, Device ID, Device Type, Desired Software, Current Config PN, Last Check-In, Queued, Downloaded, Flashed, Auto-Retry 1, Auto-Retry 2, Reported Software, Comments';
export const postAccessors = [
  `make`,
  'serialNumber',
  'deviceId',
  'deviceType',
  'desiredFirmware',
  'configPartNumber',
  'lastCheckInTime',
  'queued',
  'downloaded',
  'flashed',
  'autoRetryFailed1',
  'autoRetryFailed2',
  'reportedSoftware',
  'removedDueToInactivity',
  'postFlashComment',
];

export const queueAndFlashSoftwareHeaderString = `Make, Serial Number, TransactionId, Code, Description, Device Characterization, Device Id, Device Key, Device Type, File Type Id, Hash, Telematics Asset Id,\n`;
export const queueAndFlashSoftwareAccessors = [
  'make',
  'serialNumber',
  'transactionId',
  'code',
  'description',
  'deviceCharacterization',
  'deviceId',
  'deviceKey',
  'deviceType',
  'fileTypeId',
  'hash',
  'telematicsAssetId',
];
export const uploadSoftwareConfigFileHeaderString = `Make, Serial Number, TransactionId, Code, Description, Device Characterization, Device Id, Device Key, Device Type, File Type Id, Hash, Telematics Asset Id,\n`;
export const uploadSoftwareConfigFileAccessors = [
  'make',
  'serialNumber',
  'transactionId',
  'code',
  'description',
  'deviceCharacterization',
  'deviceId',
  'deviceKey',
  'deviceType',
  'fileTypeId',
  'hash',
  'telematicsAssetId',
];

export const wakeUpDevicesHeaderString = `Make, Serial Number, TransactionId, Code, Description, DeviceCharacterization,\n`;
export const wakeUpDevicesAccessors = [
  'make',
  'serialNumber',
  'transactionId',
  'code',
  'description',
  'deviceCharacterization',
];
export const downloadModemOnlyFlashTemplate = () => {
  createTemplate(csvModemOnlyFlash,'modem_flash_template.csv');
};
